import './requestNoteSection.scss';

import { RichEditorView } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import bemFactory from 'react-bem-factory';

import { messages } from './RequestNoteSection.messages';
import { RequestNoteSectionProps } from './RequestNoteSection.types';

const bem = bemFactory.block('reql-request-note-section');
const qa = bemFactory.block('reql-request-note-section');

export const RequestNoteSection = memo<RequestNoteSectionProps>((props) => {
    const { className, text } = props;

    if (!text) {
        return null;
    }

    return (
        <div className={bem.add(className)()}>
            <div className={bem('field')}>
                <div className={bem('label')}>{messages.poNoteForApproversText}</div>

                <RichEditorView html={text} dataQa={qa('value')} highlightUrls />
            </div>
        </div>
    );
});

RequestNoteSection.displayName = 'RequestNoteSection';
